var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadgeEvent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "46px",
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / badge_event") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-badge_event",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#A7ACB0",
    strokeWidth: 0,
    cx: 23,
    cy: 23,
    r: 23
  }), /*#__PURE__*/React.createElement("g", {
    id: "event",
    transform: "translate(8.000000, 8.000000)",
    stroke: "#0F2B41",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(5.000000, 2.857143)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 2,
    x: 0,
    y: 2.28571429,
    width: 20.5714286,
    height: 20.5714286,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.80952381,0.4 L3.80952381,4.63448276",
    id: "Line-3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3809524,0.4 L16.3809524,4.63448276",
    id: "Line-3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,9.03831845 L20.5714286,9.03831845",
    id: "Line-4",
    strokeWidth: 2
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeEvent);
export default __webpack_public_path__ + "static/media/badgeEvent.16111bbd0f1df4ff9764a27eb3b39d53.svg";
export { ForwardRef as ReactComponent };